<template>
  <table-component
    ref="userTable"
    :data="fetchData"
    sort-by="name"
    sort-order="asc"
    :show-caption="false"
    class="datatable"
    filter-placeholder=""
    filterNoResults="">
    <table-column
      show="username"
      :label="$t('user.name')"
      header-class="text-left"
      cell-class="table-component__text-left">
    </table-column>
    <table-column
      show="email"
      :label="$t('user.email')"
      header-class="text-left"
      cell-class="table-component__text-left">
    </table-column>
    <table-column
      show="supervisor"
      :label="$t('health.sensor.supervisor')"
      :formatter="supervisorFormatter"
      header-class="text-left"
      cell-class="table-component__text-left">
    </table-column>
    <table-column
      show="time"
      :formatter="timeFormatter"
      :label="$t('health.sensor.time')"
      header-class="table-component__medium__width__column"
      cell-class="text-center">
    </table-column>
  </table-component>
</template>

<script>
import TableComponent from '@/components/shared/table/components/TableComponent';
import TableColumn from '@/components/shared/table/components/TableColumn';
import pagination from '@/components/shared/table/pagination';

export default {
  name: 'NutriSensorTable',
  components: {
    TableComponent,
    TableColumn
  },
  data () {
    return {
      tablePageSize: 10,
      tableState: {
        filter: '',
        page: 1,
        sort: {
          order: '',
          fieldName: ''
        }
      }
    };
  },
  props: {
    chartData: {
      default: []
    }
  },
  watch: {
    getItems: {
      handler: function () {
        this.$refs.userTable.refresh();
      }
    }
  },
  computed: {
    getItems () {
      return this.chartData;
    }
  },
  methods: {
    timeFormatter (timestamp) {
      const start = Date.now();
      // get total seconds between the times
      let delta = Math.abs(start - timestamp) / 1000;

      // calculate (and subtract) whole days
      const days = Math.floor(delta / 86400);
      delta -= days * 86400;

      // calculate (and subtract) whole hours
      const hours = Math.floor(delta / 3600) % 24;

      const sdays = (days !== 0) ? this.$t('health.sensor.day') + ': ' + days + ' /' : '';
      const shours = this.$t('health.sensor.hour') + ': ' + hours;

      return sdays + ' ' + shours;
    },
    supervisorFormatter (supervisor) {
      if (supervisor) {
        return supervisor.join(', ');
      }
    },
    fetchData ({ page, filter, sort }) {
      const tablePage = pagination.createPage(
        this.getItems,
        this.tableState,
        ['username', 'email'],
        this.tablePageSize,
        { page, filter, sort });
      this.tableState = tablePage.state;
      return tablePage.result;
    }
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/brand/health/components/sensortable/SensorTable.vue